import { render } from "./UiToastList.vue?vue&type=template&id=eced1a16&scoped=true"
import script from "./UiToastList.vue?vue&type=script&lang=js"
export * from "./UiToastList.vue?vue&type=script&lang=js"

import "./UiToastList.vue?vue&type=style&index=0&id=eced1a16&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eced1a16"]])

export default __exports__